import { Chantier } from './json-interface';
import {MESH_UNIT} from './const';

/**
 * Informations en memoire
 */
export class g_params {

  private constructor() {}
  public static g_appInit: boolean = false;
  public static g_factoryName: string = '';
  public static g_arraySite: Chantier[] = [];
  public static measureUnitStr: string|'mm'|'cm'|'M' = '';
  public static shapeCode99: string;
  public static useJoiningCode: boolean = false;
  public static OPT_WMESH: boolean = false; // Option welded mesh pour HOD 181
  public static nbMinMesh: number = 1;
  public static inputSteelAndProduct: boolean = false;
  public static unitDimPlaqueMesh: number = 0;
  public static minOpenDateBetweenCreateAndDelivery = 0;

  public static unitDimPlaqueMeshStr(): string {
    switch (g_params.unitDimPlaqueMesh) {
      case MESH_UNIT.MESH_UNIT_Cm:  return 'cm';
      case MESH_UNIT.MESH_UNIT_mm:  return 'mm';
      case MESH_UNIT.MESH_UNIT_m:   return 'm';
      default:                      return '?';
    }
  }
}
